


























/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import TheEducation from '../user-adviser-details-components/TheEducation.vue'
import ThePersonalDetails from '../user-adviser-details-components/ThePersonalDetails.vue'
import TheRecruitmentChecklist from '../user-adviser-details-components/TheRecruitmentChecklist.vue'
import TheSpouse from '../user-adviser-details-components/TheSpouse.vue'
import ThePersonalItems from '../user-adviser-details-components/ThePersonalItems.vue'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { UIService } from '@core/services/UIService'
import { UserAdviserDetailsMeta } from '../user-adviser-details-components/model/UserAdviserDetailsMeta'
import TheFinancingDetails from '../user-adviser-details-components/TheFinancingDetails.vue'

const userStore = namespace('UserStore')

@Component({
  components: {
    TheEducation,
    ThePersonalDetails,
    TheRecruitmentChecklist,
    TheSpouse,
    ThePersonalItems,
    TheFinancingDetails
  }
})
export default class UserAdviserDetails extends Vue {
  @inject()
  private $api: API

  uiService: UIService

  private activeName = 'first'

  @userStore.State
  private userAdviserDetails!: UserAdviserDetailsMeta

  @userStore.Action
  private fetchAdviserDetails: (adviserOid: string) => Promise<void>

  get userOid (): string {
    return this.$route.params.userOid as string || this.$store.getters.currentUser.accountID
  }

  get isSuperUser () {
    return this.$store.getters.currentUser.isSuperUser
  }

  get isOpsStaff () {
    return this.$store.getters.currentUser.systemrole === 'ops-staff'
  }

  async onSubmit () {
    const dataToSave: any = {
      ...this.userAdviserDetails.convertToRawData(null, true),
      user_oid: this.userOid
    }

    await this.$api.adviserDetails.saveDetails({
      adviser_oid: this.userOid,
      data: JSON.stringify(dataToSave)
    })
  }

  async created () {
    this.$parent.$on('save', this.onSubmit)
  }

  async mounted () {
    await this.fetchAdviserDetails(this.userOid)
  }
}

